export const IMAGE_GRID_LINK = {
  _id: { $oid: '61cb6a9d7d357455147796f5a' },
  label: 'This is an image grid',
  type: 'image-grid',
  image_grid_options: {
    limit: 3,
    show_message: true,
    message: 'Tap any photo to visit the link',
  },
  items: [
    {
      _id: { $oid: '61cb6a9d7d357455147796f5b' },
      enabled: true,
      image: {
        url: '/home/image-grid/grid-1.png',
      },
      media_type: 'image',
      title: '',
      urls: [
        {
          url: 'https://campsite.bio',
        },
      ],
    },
    {
      _id: { $oid: '61cb6a9d7d357455147796f5c' },
      enabled: true,
      image: {
        url: '/home/image-grid/grid-2.png',
      },
      media_type: 'image',
      title: '',
      urls: [
        {
          url: 'https://campsite.bio',
        },
      ],
    },
    {
      _id: { $oid: '61cb6a9d7d357455147796f5d' },
      enabled: true,
      image: {
        url: '/home/image-grid/grid-3.png',
      },
      media_type: 'image',
      title: '',
      urls: [
        {
          url: 'https://campsite.bio',
        },
      ],
    },
  ],
};

export const FEED_LINK = {
  _id: { $oid: '61cb6a9d7d357455147796f5' },
  label: 'This is a feed link',
  type: 'feed',
  feed_options: {
    layout: 'stacked',
    limit: 3,
    items: [
      {
        title: 'Our feed links are auto-magic',
        url: 'https://campsite.bio',
      },
      {
        title: 'Pull in all your latest blog posts or Youtube videos',
        url: 'https://campsite.bio',
      },
      {
        title: 'Sign up for Campsite Pro',
        url: 'https://campsite.bio',
      },
    ],
  },
};

export const CAROUSEL_LINK = {
  _id: { $oid: '5dac98863548b44ba4d46db1' },
  type: 'carousel',
  banners: [
    {
      _id: { $oid: '5dac98863548b44ba4d46db2' },
      number_of_clicks: 129,
      position: 2,
      enabled: true,
      image_alt:
        'The possibilities are endless with Campsite Pro! Sign up Today!',
      media: { $oid: '5e9cd9c71d76003f5cd89445' },
      url: 'https://campsite.bio/pricing',
      updated_at: '2019-11-02 19:19:07 UTC',
    },
    {
      _id: { $oid: '5dac98de3548b44ba4d46e02' },
      number_of_clicks: 34,
      position: 3,
      enabled: true,
      updated_at: '2019-10-20 17:27:22 UTC',
      created_at: '2019-10-20 17:26:54 UTC',
      image_alt: 'Embed a Campsite into your own website',
      media: { $oid: '5e9cd9c995aa253f57d0eb57' },
      url: 'https://campsite.bio/demo/embedded-campsite',
    },
  ],
  is_carousel_random: false,
  custom_banner_media: [
    {
      _id: { $oid: '5e9cd9c71d76003f5cd89445' },
      url: '/home/carousels/carousel-1.png',
    },
    {
      _id: { $oid: '5e9cd9c995aa253f57d0eb57' },
      url: '/home/carousels/carousel-2.png',
    },
  ],
  custom_media: [],
  carousel_options: {
    is_carousel_random: false,
    height_ratio: 69,
    hide_arrows: true,
  },
};

export const OPT_IN_LINK = {
  _id: { $oid: '5cfd6801c67c277101db74f0' },
  type: 'opt-in-form',
  label: 'Collect email addresses or phone numbers',
  campsite_id: { $oid: '5cfd65fac67c277101db7472' },
  email_options: {
    success_message: "You're all set! Thanks for signing up",
    email_label: 'Enter your email',
    button_text: 'Sign Up',
    source: 'mailchimp',
    has_setup: true,
    enable_double_opt_in: true,
    show_legal_info: false,
    merge_fields: [
      {
        _id: { $oid: '5e70bb19612a013f498372b6' },
        visible: true,
        label: 'First Name',
        name: 'FNAME',
        required: true,
        hint_text: 'John',
      },
      {
        _id: { $oid: '61bde9ec7d35740d64e00cea' },
        visible: true,
        name: 'email',
        label: 'Email Address',
        required: true,
        is_default: true,
        hint_text: 'john@gmail.com',
      },
    ],
    type: 'email',
  },
  custom_banner_media: [],
  custom_media: [],
};

export const PROFILE_DEFAULT = {
  profile: {
    _id: { $oid: '6113e16d7d35741c1c8de5e2' },
    enabled: true,
    profile_image:
      'https://cdn.campsite.bio/camper/27383516-c8cb-4e5a-9eca-13b5e4873f20.png',
    site_bg_color: '#EDE8E5',
    site_bg_colors: ['#EDE8E5', '#DDD7D2'],
    site_bg_style: 'gradient',
    site_button_bg_color: '#0059FF',
    site_button_border_color: '#306C63',
    site_button_style: 'filled',
    site_button_border_width: 'thin',
    site_button_color: '#fff',
    site_button_corner_radius: 'circular',
    site_button_font_family: 'Open Sans',
    site_button_font_family_details: {
      category: 'sans-serif',
      family: 'Open Sans',
      font_family: "'Open Sans', sans-serif",
      variants: [
        '300',
        '300italic',
        'regular',
        'italic',
        '500',
        '500italic',
        '600',
        '600italic',
        '700',
        '700italic',
        '800',
        '800italic',
      ],
      is_google_font: true,
    },
    site_button_font_weight: '700',
    site_button_image_size: 'small',
    site_button_image_style: null,
    site_carousel_bg_color: '#dddddd',
    site_carousel_loader_color: '#444444',
    site_font_family: 'Open Sans',
    site_font_family_details: {
      category: 'sans-serif',
      family: 'Open Sans',
      font_family: "'Open Sans', sans-serif",
      variants: [
        '300',
        '300italic',
        'regular',
        'italic',
        '500',
        '500italic',
        '600',
        '600italic',
        '700',
        '700italic',
        '800',
        '800italic',
      ],
      is_google_font: true,
    },
    site_hide_branding: false,
    site_hide_intro_title: false,
    site_hide_profile_image: false,
    site_intro_title: 'Your Campsite.bio Profile',
    site_intro_text: 'Help me out and drag those items over!',
    site_profile_image_border: true,
    site_profile_image_border_color: '#e9e9e9',
    site_social_color: '#000',
    site_social_position: 'top',
    site_text_color: '#222',
    site_theme: 'custom',
    subdomain: 'camperdude',
    username: 'camper',
    username_lowercase: 'camper',
  },
  links: [
    {
      _id: { $oid: '61cb6a9d7d357455147796f5' },
      label: 'Buy Our Widgets',
      url: 'https://campsite.bio',
      enabled: true,
    },
    {
      _id: { $oid: '61cb6a9d7d357455147796f6' },
      label: 'Our Latest Blogs',
      type: 'feed',
      enabled: true,
      feed_options: {
        layout: 'stacked',
        limit: 3,
        items: [
          {
            title: 'Feed links are auto-magic',
            url: 'https://campsite.bio',
          },
          {
            title: 'Pull in all your latest blogs or Youtube videos',
            url: 'https://campsite.bio',
          },
          {
            title: 'Without having to do anything',
            url: 'https://campsite.bio',
          },
        ],
      },
    },
  ],
  socialAccounts: [
    {
      _id: { $oid: '6151e03d7d35741868826877' },
      number_of_clicks: 0,
      position: 1,
      type: 'instagram',
      url: 'https://www.instagram.com/campsite.bio/',
    },
    {
      _id: { $oid: '6151e0457d35741868826878' },
      number_of_clicks: 0,
      position: 2,
      type: 'twitter',
      url: 'https://twitter.com/campsitebio',
    },
    {
      _id: { $oid: '615f0a2f7d357415908711af' },
      number_of_clicks: 0,
      position: 3,
      type: 'email',
      url: 'support@campsite.bio',
    },
  ],
  defaultProfileImage: 'https://cdn.campsite.bio/default-profile-image.png',
};
